const selectorDefinitions = [];
export default selectorDefinitions;
